// eslint-disable-next-line jira/restricted/relay-runtime
import { Environment } from 'relay-runtime';
import { getRelayEnvironmentConfig } from '@atlassian/jira-relay-environment-config/src/index.tsx';
import { getNetworkOptions } from '@atlassian/jira-relay-fetch';
import relayLogHandler, { requiredFieldLogger } from '@atlassian/jira-relay-log/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { functionWithCondition } from '@atlassian/jira-feature-flagging-utils';
import { createRelayEnvironment } from '@atlassian/relay-environment/createRelayEnvironment';

let relayEnvironment: Environment;
let platformRelayEnvironment: Environment;

function getPlatformRelayEnvironment() {
	if (!platformRelayEnvironment) {
		const sharedRelayEnvironmentConfig = {
			log: relayLogHandler,
			relayFieldLogger: requiredFieldLogger,
			networkOptions: getNetworkOptions(),
		};
		platformRelayEnvironment = createRelayEnvironment(sharedRelayEnvironmentConfig);
	}
	return platformRelayEnvironment;
}

function getOriginalRelayEnvironment() {
	if (!relayEnvironment) {
		const environmentConfig = getRelayEnvironmentConfig();
		relayEnvironment = new Environment(environmentConfig);
	}
	return relayEnvironment;
}

export default functionWithCondition(
	() => fg('platform_relay_use_shared_environment_in_jira'),
	getPlatformRelayEnvironment,
	getOriginalRelayEnvironment,
);
